import type { UntitledIconData } from '@faceup/icons'

export const ucPauseButton: UntitledIconData = {
  prefix: 'custom',
  name: 'ucPauseButton',
  viewBox: '0 0 24 24',
  paths: [
    {
      shape:
        'M12 22C17.5229 22 22 17.5228 22 12C22 6.47716 17.5229 2 12 2C6.47713 2 2 6.47716 2 12C2 17.5228 6.47713 22 12 22ZM10.6666 8.66667C10.2984 8.66667 9.99991 8.96516 9.99991 9.33334V14.6667C9.99991 15.0348 10.2984 15.3333 10.6666 15.3333C11.0348 15.3333 11.3333 15.0348 11.3333 14.6667V9.33334C11.3333 8.96516 11.0348 8.66667 10.6666 8.66667ZM13.3332 8.66667C12.9651 8.66667 12.6666 8.96516 12.6666 9.33334V14.6667C12.6666 15.0348 12.9651 15.3333 13.3332 15.3333C13.7014 15.3333 13.9999 15.0348 13.9999 14.6667V9.33334C13.9999 8.96516 13.7014 8.66667 13.3332 8.66667Z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
}
